import { render, staticRenderFns } from "./ElecConsume.vue?vue&type=template&id=252d0bac&"
import script from "./ElecConsume.vue?vue&type=script&lang=js&"
export * from "./ElecConsume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports